import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, PackageCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, GradButton } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { SonFiyat } from "@/components/SonFiyat";
import { useAuth } from "@/context/AuthContext";
import { PARA } from "@/lib/perms";
import api, { errMsg } from "@/lib/api";

const Kapat = ({ onClose, testid }) => <button onClick={onClose} className="px-5 py-2 rounded-full border border-white/10 text-sm" data-testid={testid}>Vazgeç</button>;

export const YeniSADialog = ({ tedarikciler, tedarikciId = "", onClose, onSaved }) => {
  const { ayar } = useAuth();
  const [urunler, setUrunler] = useState([]);
  const [f, setF] = useState({ tedarikci_id: tedarikciId, para_birimi: "TRY", kur: 1, termin_tarihi: "", notlar: "" });
  const [kalemler, setKalemler] = useState([{ urun_id: "", miktar: 1, birim_fiyat: 0 }]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/urunler").then((r) => setUrunler(r.data.filter((u) => u.aktif && u.stok_takibi))); }, []);
  const setK = (i, k, v) => setKalemler((l) => l.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/satinalma/siparisler", { ...f, termin_tarihi: f.termin_tarihi || null, kalemler: kalemler.filter((k) => k.urun_id) });
      toast.success(`${data.no} oluşturuldu`);
      onSaved(data);
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-2xl max-h-[92vh] overflow-y-auto erp-scroll" data-testid="sa-yeni-dialog">
        <DialogHeader><DialogTitle className="font-head">Yeni satın alma siparişi</DialogTitle></DialogHeader>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Tedarikçi *" className="sm:col-span-2"><SelectBox testid="sa-tedarikci" value={f.tedarikci_id} onChange={(v) => setF((s) => ({ ...s, tedarikci_id: v }))} options={tedarikciler.map((c) => ({ value: c.id, label: c.unvan }))} /></Field>
          <Field label="Para birimi"><SelectBox testid="sa-para" value={f.para_birimi} onChange={(v) => setF((s) => ({ ...s, para_birimi: v, kur: v === "TRY" ? 1 : Number(ayar?.kurlar?.[v] || 0) }))} options={PARA} /></Field>
          <Field label="Termin"><Input data-testid="sa-termin" type="date" className="bg-white/5" value={f.termin_tarihi} onChange={(e) => setF((s) => ({ ...s, termin_tarihi: e.target.value }))} /></Field>
        </div>
        <div className="space-y-2">
          {kalemler.map((k, i) => (
            <div key={i} className="grid grid-cols-[minmax(0,1fr)_90px_130px_36px] gap-2 items-start" data-testid={`sa-kalem-${i}`}>
              <Field label={i === 0 ? "Ürün" : ""}><SelectBox urun testid={`sa-urun-${i}`} value={k.urun_id} onChange={(v) => setK(i, "urun_id", v)} options={urunler.map((u) => ({ value: u.id, label: `${u.kod} · ${u.ad}` }))} /></Field>
              <Field label={i === 0 ? "Miktar" : ""}><Input data-testid={`sa-miktar-${i}`} type="number" step="any" className="bg-white/5" value={k.miktar} onChange={(e) => setK(i, "miktar", Number(e.target.value))} /></Field>
              <Field label={i === 0 ? "Birim fiyat" : ""}><Input data-testid={`sa-fiyat-${i}`} type="number" step="any" className="bg-white/5" value={k.birim_fiyat} onChange={(e) => setK(i, "birim_fiyat", Number(e.target.value))} />
                <SonFiyat tur="alis" urunId={k.urun_id} testid={`sa-son-fiyat-${i}`} onSec={(v) => setK(i, "birim_fiyat", v)} /></Field>
              <button onClick={() => setKalemler((l) => l.filter((_, j) => j !== i))} className={`h-10 flex items-center justify-center text-muted-foreground hover:text-red-400 ${i === 0 ? "mt-6" : ""}`} data-testid={`sa-kalem-sil-${i}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
          <button onClick={() => setKalemler((l) => [...l, { urun_id: "", miktar: 1, birim_fiyat: 0 }])} className="text-xs text-[var(--g1)] inline-flex items-center gap-1" data-testid="sa-kalem-ekle"><Plus className="w-3.5 h-3.5" />Kalem ekle</button>
        </div>
        <div className="flex justify-end gap-2"><Kapat onClose={onClose} testid="sa-vazgec" /><GradButton onClick={save} disabled={busy} data-testid="sa-kaydet">Sipariş oluştur</GradButton></div>
      </DialogContent>
    </Dialog>
  );
};

const KabulSatiri = ({ k, i, r, set, skt }) => {
  const kalan = +(k.miktar - (k.kabul_miktar || 0)).toFixed(6);
  return (
    <div className={`rounded-xl p-3 transition-colors ${r.sec ? "bg-white/[0.06]" : "bg-white/[0.02] opacity-60"}`} data-testid={`kabul-kalem-${k.kod}`}>
      <label className="flex items-center gap-2.5 text-sm cursor-pointer">
        <Checkbox data-testid={`kabul-sec-${i}`} checked={r.sec} onCheckedChange={(v) => set(i, "sec", !!v)} />
        <span className="font-mono text-xs text-muted-foreground">{k.kod}</span>{k.ad}
        <span className="ml-auto text-xs text-muted-foreground">sipariş {k.miktar} · gelen {k.kabul_miktar || 0} · kalan {kalan} {k.birim}</span>
      </label>
      {r.sec && <div className={`grid gap-2 mt-2 ${skt ? "grid-cols-3" : "grid-cols-2"}`}>
        <Input data-testid={`kabul-miktar-${i}`} type="number" step="any" className="bg-white/5" placeholder="Gelen miktar" value={r.miktar} onChange={(e) => set(i, "miktar", e.target.value)} />
        <Input data-testid={`kabul-lot-${i}`} className="bg-white/5" placeholder={skt ? "Lot *" : "Lot (opsiyonel)"} value={r.lot} onChange={(e) => set(i, "lot", e.target.value)} />
        {skt && <Input data-testid={`kabul-skt-${i}`} type="date" className="bg-white/5" value={r.skt} onChange={(e) => set(i, "skt", e.target.value)} />}
      </div>}
    </div>
  );
};

export const MalKabulDialog = ({ p, onClose, onSaved }) => {
  const { ayar } = useAuth();
  const [depolar, setDepolar] = useState([]);
  const [rows, setRows] = useState(p.kalemler.map((k) => { const kalan = +(k.miktar - (k.kabul_miktar || 0)).toFixed(6); return { sec: kalan > 0, miktar: kalan, lot: "", skt: "", kalan }; }));
  const [f, setF] = useState({ depo_id: "", cariye_yaz: true, irsaliye_no: "", aciklama: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/depolar").then((r) => {
      const d = r.data.filter((x) => x.aktif !== false && x.tip !== "karantina");
      setDepolar(r.data);
      setF((s) => ({ ...s, depo_id: (d.find((x) => x.tip === "hammadde") || d[0] || {}).id || "" }));
    });
  }, []);
  const set = (i, k, v) => setRows((l) => l.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const save = async () => {
    const satirlar = rows.map((r, i) => ({ kalem_idx: i, miktar: Number(r.miktar), lot: r.lot, skt: r.skt })).filter((s, i) => rows[i].sec && s.miktar > 0);
    if (!satirlar.length) return toast.error("Kabul edilecek en az bir kalem işaretleyin");
    setBusy(true);
    try {
      const { data } = await api.post(`/satinalma/siparisler/${p.id}/mal-kabul`, { ...f, satirlar });
      toast.success(`Mal kabul edildi · ${satirlar.length} kalem stoğa girdi`);
      onSaved(data);
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-2xl max-h-[92vh] overflow-y-auto erp-scroll" data-testid="mal-kabul-dialog">
        <DialogHeader><DialogTitle className="font-head">Mal kabul · {p.no} · {p.tedarikci_unvan}</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground -mt-2">Gelen her hammaddeyi işaretleyip miktarını girin; işaretsiz kalemler beklemeye devam eder.</p>
        <div className="space-y-2">{p.kalemler.map((k, i) => (rows[i].kalan > 0 ? <KabulSatiri key={i} k={k} i={i} r={rows[i]} set={set} skt={!!ayar?.lot_skt_zorunlu} /> : null))}</div>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Giriş deposu *"><SelectBox testid="kabul-depo" value={f.depo_id} onChange={(v) => setF((s) => ({ ...s, depo_id: v }))} options={depolar.map((d) => ({ value: d.id, label: d.ad }))} /></Field>
          <Field label="Tedarikçi irsaliye no"><Input data-testid="kabul-irsaliye" className="bg-white/5" value={f.irsaliye_no} onChange={(e) => setF((s) => ({ ...s, irsaliye_no: e.target.value }))} /></Field>
          <Field label="Açıklama" className="sm:col-span-2"><Input data-testid="kabul-aciklama" className="bg-white/5" value={f.aciklama} onChange={(e) => setF((s) => ({ ...s, aciklama: e.target.value }))} /></Field>
        </div>
        <label className="flex items-start gap-2.5 text-sm cursor-pointer select-none rounded-xl bg-white/[0.04] p-3" data-testid="kabul-cariye-yaz-label">
          <Checkbox data-testid="kabul-cariye-yaz" checked={f.cariye_yaz} onCheckedChange={(v) => setF((s) => ({ ...s, cariye_yaz: !!v }))} className="mt-0.5" />
          <span>Tedarikçi cari hesabına borç yaz<span className="block text-xs text-muted-foreground">İşaretsizse yalnızca stok girer; tutar sonra alış faturasıyla işlenir.</span></span>
        </label>
        <div className="flex justify-end gap-2"><Kapat onClose={onClose} testid="kabul-vazgec" /><GradButton onClick={save} disabled={busy} data-testid="kabul-kaydet"><PackageCheck className="w-4 h-4" />Kabul et</GradButton></div>
      </DialogContent>
    </Dialog>
  );
};
